import { ValidationIcon_default } from "./chunk-N7RSLTZJ.js";
import { InputComponent } from "./chunk-DBD5CSY6.js";
import { Spinner_default } from "./chunk-3P5HEDZF.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Select/Select.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var Select = forwardRef((_a, ref) => {
  var _b = _a,
    {
      variant = "secondary",
      disabled,
      validation,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["variant", "disabled", "validation", "isLoading", "className"]);
  return /* @__PURE__ */jsxs(InputComponent, {
    variant,
    validation: variant === "secondary" ? validation : void 0,
    disabled,
    className: clsx("pd:select", isLoading && "pd:select--loading", variant === "secondary" && validation && "pd:select--validation", className),
    children: [/* @__PURE__ */jsx(InputComponent.Input, __spreadValues({
      ref,
      as: "select",
      isLoading,
      className: "pd:select__input"
    }, rest)), variant === "secondary" && validation && !isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
      children: /* @__PURE__ */jsx(ValidationIcon_default, {
        variant: validation
      })
    }), isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
      children: /* @__PURE__ */jsx(Spinner_default, {
        variant: "primary"
      })
    })]
  });
});
var Select_default = Select;
export { Select_default };